module.exports = __webpack_public_path__ + "static/media/candle_patterns.38784fcf.svg";